import { useState } from "react";
import "./styles.scss";

const Stars = ({ rating }) => (
  <div className="stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <span
        key={s}
        className={`star ${rating >= s ? "full" : rating >= s - 0.5 ? "half" : "empty"}`}
      >
        ★
      </span>
    ))}
  </div>
);

const CartControl = ({ onAdd }) => {
  const [qty, setQty] = useState(0);

  const add = () => {
    onAdd?.();
    setQty(1);
  };
  const inc = () => setQty((q) => q + 1);
  const dec = () => setQty((q) => (q <= 1 ? 0 : q - 1));

  return (
    <div className="cart-area">
      <button
        className={`add-btn ${qty > 0 ? "add-btn--hidden" : ""}`}
        onClick={add}
      >
        <span className="add-btn__icon">🛒</span>
        Add to cart
      </button>

      <div className={`stepper ${qty > 0 ? "stepper--visible" : ""}`}>
        <button className="stepper__btn" onClick={dec} aria-label="Decrease">
          −
        </button>
        <span className="stepper__num">{qty}</span>
        <button className="stepper__btn" onClick={inc} aria-label="Increase">
          +
        </button>
      </div>
    </div>
  );
};

const ProductCard = ({
  image,
  name,
  desc,
  price,
  originalPrice,
  rating = 0,
  reviewCount = 0,
  badge = null, // "discount" | "new" | null
  discountPercent,
}) => {
  const [wished, setWished] = useState(false);
  const savings = originalPrice ? (originalPrice - price).toFixed(2) : null;

  return (
    <div className="product-card">
      <div className="product-card__img-wrap">
        {badge === "discount" && discountPercent && (
          <span className="product-card__badge product-card__badge--discount">
            -{discountPercent}%
          </span>
        )}
        {badge === "new" && (
          <span className="product-card__badge product-card__badge--new">
            New
          </span>
        )}

        <button
          className={`product-card__wish ${wished ? "product-card__wish--on" : ""}`}
          onClick={() => setWished((w) => !w)}
          aria-label={wished ? "Remove from wishlist" : "Add to wishlist"}
        >
          {wished ? "♥" : "♡"}
        </button>

        <img src={image} alt={name} className="product-card__image" />
      </div>

      <div className="product-card__body">
        <p className="product-card__name">{name}</p>
        <p className="product-card__desc"> {desc} </p>

        <div className="product-card__prices">
          <span className="product-card__price">${price.toFixed(2)}</span>
          {originalPrice && (
            <span className="product-card__original">
              ${originalPrice.toFixed(2)}
            </span>
          )}
        </div>

        <p className="product-card__saving">
          {savings ? `You save $${savings}` : ""}
        </p>

        <div className="product-card__rating">
          <Stars rating={rating} />
          <span className="product-card__score">
            {rating.toFixed(1)}{" "}
            <span className="product-card__count">({reviewCount})</span>
          </span>
        </div>

        <CartControl />
      </div>
    </div>
  );
};

export default ProductCard;

// export const ProductCardDemo = () => (
//   <div style={{ display: "flex", gap: 24, flexWrap: "wrap", padding: "2rem" }}>
//     <ProductCard
//       image="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400"
//       name="Bose QuietComfort 45 Wireless Headphones"
//       price={279}
//       originalPrice={349}
//       rating={4.6}
//       reviewCount={218}
//       badge="discount"
//       discountPercent={20}
//     />
//     <ProductCard
//       image="https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=400"
//       name="Sony WF-1000XM5 True Wireless Earbuds"
//       price={299}
//       rating={4.2}
//       reviewCount={84}
//       badge="new"
//     />
//   </div>
// );
